import React, { Component } from 'react'
import { ManageGroups } from '../../components'
import firebase from 'firebase'
import { groups as ref } from '../../config/firebaseconfig'
import { db } from '../../config/firebaseconfig'
import PropTypes from 'prop-types'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import * as groupsActionCreators from '../../redux/modules/groups'
import arrayify from '../../helpers/arrayify'
import disarrayify from '../../helpers/disarrayify'

const uuid = require('uuid/v1')

// just getting 20 most recent users right now. Eventually need filtering

class ManageGroupsContainer extends Component {
  constructor (props) {
    super (props)

    this.state = {
      groupName: '',
      groupType: 'District',
    }
    
    this.handleChange = this.handleChange.bind(this)
    this.handleSubmit = this.handleSubmit.bind(this)
    this.addMember =  this.addMember.bind(this)
    this.removeMember = this.removeMember.bind(this)
    this.addManager = this.addManager.bind(this)
    this.removeManager = this.removeManager.bind(this)
  }

  handleChange(e) {
    const value = e.target.value
    this.setState({
      [e.target.name] : value
    })
  }

  handleSubmit(e) {
    e.preventDefault()
    this.props.creatingGroups()
    const groupId = uuid()
    const date = new Date
    db.collection('groups').doc(groupId).set({
        ...this.state,
        groupId,
        lastUpdated: date.getTime(),
        createdDate: date.getTime(),
    }).then( (res) => {
      this.props.creatingGroupsSuccess()
      this.setState({ groupName: '' })
    })
    .catch( (error) => {
      this.props.creatingGroupsFailure()
    })
  }

  componentDidMount() {
    this.props.fetchingGroups()
    this.groupsUnsubscribe = db.collection('groups').orderBy('createdDate', 'desc').limit(10)
      .onSnapshot( (snapshot) => { 
        let tenGroups = []
        snapshot.forEach( (group) => tenGroups.push(group.data()))
        this.props.fetchingGroupsSuccess(tenGroups)
      })

// need to not use arrayify or disarrayify bc diff data structure

/*   THIS VERSION USES ARRAYS. WANT TO USE OBJECTS.

    this.props.fetchingUsers()
    db.collection('users').orderBy('createdDate', 'desc').limit(20)
      .onSnapshot( (snapshot) => {
        const usersList = []
        snapshot.forEach( (user) => {
          const data = user.data()

          let gps
          data.groups === {} || !data.groups
          ? gps = []
          : gps = arrayify(data.groups)

          let mgGps
          data.managesGroups === {} || !data.managesGroups
          ? mgGps = []
          : mgGps = arrayify(data.managesGroups)

          const userToAddToList = {
            ...data,
            groups: gps,
            managesGroups: mgGps,
          }
          usersList.push(userToAddToList)
        })
        this.props.fetchingUsersSuccess(usersList)
      },
      (error) => this.props.fetchingUsersError(error)
    )

*/

    this.props.fetchingUsers()
    this.usersUnsubscribe = db.collection('users').orderBy('createdDate', 'desc').limit(20)
      .onSnapshot( (snapshot) => {
        const usersList = []
        snapshot.forEach( (user) => {
          usersList.push(user.data())
        })
        this.props.fetchingUsersSuccess(usersList)
      },
      (error) => this.props.fetchingUsersError(error)
    )
      
      
      
      /*this.props.fetchingGroupsSuccess(snapshot.data()) */
//    ref.on('value',(snapshot) => this.props.fetchingGroupsSuccess(snapshot.val()))
  }

// update the group and the member

  addMember(memberId, groupId) {
    this.props.addingMember()
    const batch = db.batch()
    const userRef = db.collection('users').doc(memberId)
    batch.update(userRef, {['groups.' + groupId]: true })
    const groupRef = db.collection('groups').doc(groupId)
    batch.update(groupRef, {['members.' + memberId]: true})
    batch.commit()
      .then( () => this.props.addingMemberSuccess(memberId) )
      .catch( (error) => this.props.addingMemberError(error) )
  }

  removeMember(memberId, groupId) {
    this.props.removingMember()
    const batch = db.batch()
    const userRef = db.collection('users').doc(memberId)
    batch.update(userRef, {['groups.' + groupId]: false})
    const groupRef = db.collection('groups').doc(groupId)
    batch.update(groupRef, {['members.' + memberId]: false})
    batch.commit()
      .then( () => this.props.removingMemberSuccess(memberId) )
      .catch( (error) => this.props.removingMemberError(error) )
  }

  addManager(managerId, groupId) {
    this.props.addingManager()
    const batch = db.batch()
    const userRef = db.collection('users').doc(managerId)
    batch.update(userRef, {['managesGroups.' + groupId]: true})
    const groupRef = db.collection('groups').doc(groupId)
    batch.update(groupRef, {['managers.' + managerId]: true})
    batch.commit()
      .then( () => this.props.addingManagerSuccess(managerId) )
      .catch( (error) => this.props.addingManagerError(error) )
  }

  removeManager(managerId, groupId) {
    this.props.removingManager()
    const batch = db.batch()
    const userRef = db.collection('users').doc(managerId)
    batch.update(userRef, {['managesGroups.' + groupId]: false})
    const groupRef = db.collection('groups').doc(groupId)
    batch.update(groupRef, {['managers.' + managerId]: false})
    batch.commit()
      .then( () => this.props.removingManagerSuccess(managerId) )
      .catch( (error) => this.props.removingManagerError(error) )
  }
  
  componentWillUnmount() {
    if (this.groupsUnsubscribe) {
      this.groupsUnsubscribe()
    }
    if (this.usersUnsubscribe) {
      this.usersUnsubscribe()
    }
  }

  render() {
    return <ManageGroups 
      handleChange={this.handleChange} 
      handleSubmit={this.handleSubmit} 
      groupsList={this.props.groupsList} 
      error={this.props.error}
      groupName={this.state.groupName}  
      users={this.props.users}
      setActiveGroup={this.props.setActiveGroup}
      activeGroup={this.props.activeGroup}
      addMember={this.addMember}
      removeMember={this.removeMember}
      addManager={this.addManager}
      removeManager={this.removeManager}
    />
  }
}

export default connect(
  (state) => ({
    isFetching: state.groups.isFetching,
    isCreating: state.groups.isCreating,
    error: state.groups.error,
    groupsList: state.groups.groupsList,
    groupCreated: state.groups.groupCreated,
    users: state.groups.users,
    activeGroup: state.groups.activeGroup,
  }),
  (dispatch) => bindActionCreators(groupsActionCreators, dispatch)
)(ManageGroupsContainer)





// create groupsActionCreators, connect, helpers for sending and receiving group data

/*










*/


// WEBPACK FOOTER //
// ./src/containers/Users/ManageGroupsContainer.js